import { render, staticRenderFns } from "./MakeAction.vue?vue&type=template&id=b6a6299a&scoped=true"
import script from "./MakeAction.vue?vue&type=script&lang=js"
export * from "./MakeAction.vue?vue&type=script&lang=js"
import style0 from "./MakeAction.vue?vue&type=style&index=0&id=b6a6299a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a6299a",
  null
  
)

export default component.exports